import useModal from 'components/modal/useModal';
import { motifsList } from 'helper/helper';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const ReasonAppeal = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const { toggle } = useModal();
  const motifs = motifsList();

  const [selectedId, setSelectedId] = useState(null);

  const editMissionDetailReason = (idReason) => {
    toggle('mission_detail_reason');
    if (idReason === 'ctu') {
      toggle('cM_temporaire');
    } else if (idReason === 'remplacement') {
      toggle('cM_remplacement');
    } else if (idReason === 'attente_recrutement') {
      toggle('cM_attRecrutement');
    } else if (idReason === 'accroissement') {
      toggle('cM_accroissement');
    } else if (idReason === 'saisonnier') {
      toggle('cM_saisonnier');
    }
  };

  useEffect(() => {
    const type = dataCreateMission?.motif?.type;
    if (type) {
      const found = motifs.find((m) => m.type === type);
      if (found) {
        setSelectedId(found.id);
      }
    }
  }, [dataCreateMission?.motif?.type]);

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Motifs de recours</div>
      <div className="flex flex-col gap-2">
        {motifs.map((m) => {
          const isSelected = selectedId === m.id;
          return (
            <div
              key={m.id}
              className={`w-full border p-6 cursor-pointer ${
                isSelected
                  ? 'bg-yellow-50 border-yellow-500'
                  : 'bg-grey-50 border-grey-500'
              }`}
              onClick={() => editMissionDetailReason(m.id)}
            >
              {m.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const slideOverAddMissionMotif = () => {
  return (
    <div className="flex flex-col gap-8">
      <ReasonAppeal />
    </div>
  );
};

export default slideOverAddMissionMotif;
